module.exports = __webpack_public_path__ + "static/media/defaultPhoto.9b270f9a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Common/Person/defaultPhoto.svg
// module id = 194
// module chunks = 0